<template>
  <div id="products" class="px-4 py-4">
    <div class="d-flex justify-end mb-2">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'brand-create' })"
      >
        <v-icon left>
          add_circle
        </v-icon>
        Add
      </v-btn>
    </div>
    <brand-list />
  </div>
</template>
<script>
import BrandList from "@/components/brand_management/BrandList";

export default {
  components: {
    BrandList
  },
  data: () => ({}),
  computed: {}
};
</script>

<style></style>
